import { DashboardComponent } from "@/components/dashboard";

export const Dashboard = () => {
  return <DashboardComponent />;
};
